export default {
	InvoiceExport: {
		OrderNumber: 'STT',
		CompanyName: 'Tên công ty',
		CompanyTax: 'MST công ty',
		BranchName: 'Tên chi nhánh',
		BranchTax: 'MST chi nhánh',
		DepartmentName: 'Tên phòng ban',
		BuyerName: 'Tên người mua',
		BuyerFullName: 'Họ tên người mua',
		BuyerAddress: 'Địa chỉ người mua',
		BuyerTaxCode: 'MST người mua',
		BuyerInvRevEmail: 'Email nhận hóa đơn',
		TemplateNo: 'Mẫu số',
		Series: 'Ký hiệu',
		InvoiceNo: 'Số hóa đơn',
		InvoiceDate: 'Ngày hóa đơn',
		SignedDate: 'Ngày ký',
		IssueDate: 'Ngày cấp mã',
		AccountingDate: 'Ngày hạch toán',
		SupplierCode: 'Mã người bán',
		SellerName: 'Tên người bán',
		SellerAddress: 'Địa chỉ người bán',
		SellerTaxCode: 'MST người bán',
		SellerBankAccount: 'STK người bán',
		PaymentMethod: 'Hình thức thanh toán',
		Explain: 'Diễn giải',
		TotalAmountWithoutVatDisplay: 'Tổng tiền hàng',
		TotalDiscountAmount: 'Tiền chiết khấu',
		TotalHasDiscount: 'Doanh số bán chưa thuế',
		TotalHasDiscountCC: 'Doanh số bán chưa thuế quy đổi',
		TaxReduction: 'Giảm thuế',
		VatRate: 'Thuế suất',
		TotalVATAmount: 'Thuế GTGT',
		TotalVATAmountCC: 'Thuế GTGT quy đổi',
		TotalFeesAmountXML: 'Tổng tiền phí',
		AmountOtherReduction: 'Tổng giảm trừ khác',
		SpecialItem: 'Loại HH đặc trưng',
		VehicleFrameNumber: 'Số khung',
		VehicleEngineNumber: 'Số máy',
		AssetType: 'Loại tài sản',
		AssetCondition: 'Tình trạng tài sản',
		Origin: 'Xuất xứ',
		SafetyQualityCertificateNumber: 'Số giấy chứng nhận ATKT & BVMT',
		FactoryInspectionSerialNumber: 'Số seri Phiếu KTCL xuất xưởng',
		ManufacturingCountryCode: 'Mã nước sản xuất',
		RegisteredAssetTypeName: 'Tên loại tài sản đăng ký',
		ManufacturingYear: 'Năm sản xuất',
		CommercialName: 'Tên thương mại',
		BrandName: 'Tên nhãn hiệu',
		VehicleModel: 'Kiểu loại xe',
		EngineDisplacementOrPower: 'Thể tích làm việc hoặc Công suất',
		PayloadWeight: 'Trọng tải',
		SeatingCapacity: 'Số người cho phép chở',
		TransportLicensePlate: 'Biển kiểm soát',
		DeparturePoint: 'Điểm đi',
		ArrivalPoint: 'Điểm đến',
		TransportedGoodsName: 'Tên hàng hóa vận chuyển',
		ShipperName: 'Tên người gửi hàng',
		ShipperAddress: 'Địa chỉ người gửi hàng',
		ShipperTaxCode: 'MST người gửi hàng',
		ShipperIdentifier: 'Số định danh người gửi hàng',
		LandParcelInfo: 'Thửa đất',
		AttachedToLandAssetInfo: 'Tài sản gắn liền với đất',
		TotalAmount: 'Tổng tiền thanh toán',
		CcyCode: 'Loại tiền',
		ExchangeRate: 'Tỷ giá',
		TotalAmountExchange: 'Tổng tiền quy đổi',
		StickName: 'Nhãn dán',
		RefNo: 'Số chứng từ',
		Accountant: 'Người hạch toán',
		Status: 'Kết quả kiểm tra',
		CostType: 'Loại chi phí',
		StatusInvoice: 'Trạng thái hóa đơn',
		NotificationWrong: 'Thông báo sai sót',
		LicensePlate: 'Biển số xe',
		Noted: 'Ghi chú',
		CostNorms: 'Định mức chi phí',
		BeyondTheNorm: 'Vượt định mức',
		HasPdf: 'Bản thể hiện hóa đơn',
		HasXml: 'Xml hóa đơn',
		LinkSearch: 'Link tra cứu',
		SearchCode: 'Mã tra cứu',

		// Tổng hợp
		RelativeInvoice: 'Hóa đơn liên quan',
		ChangeStatusInvoiceDate: 'Ngày thay đổi trạng thái trên CQT',
		ChangeStatusInvoiceOnSystemDate: 'Ngày phát hiện thay đổi trạng thái',
		CreatedDate: 'Ngày vào hệ thống',
		AmountReductionNotTax: 'Tổng giảm trừ không chịu thuế',
		// Chi tiết
		NatureText: 'Tính chất',
		UnitName: 'Đơn vị tính',
		UnitPrice: 'Đơn giá',
		Quantity: 'Số lượng',
		BatchNo: 'Số lô',
		ExpiredDate: 'Hạn sử dụng'
	},
	DeclarationExport: {
		OrderNumber: 'STT',
		DeclarationNo: 'Số tờ khai',
		DeclarationDate: 'Ngày tờ khai',
		CreatedDate: 'Ngày vào hệ thống',
		InvoiceNo: 'Số hóa đơn',
		VatTaxableValue: 'Trị giá tính thuế GTGT',
		ExporterName: 'Người xuất khẩu',
		BuyerAddress: 'Địa chỉ',
		TotalDeclarationAmount: 'Tổng trị giá hóa đơn',
		TotalDeclarationAmountExchange: 'Tổng trị giá hóa đơn quy đổi',
		TotalPreCustomsFee: 'Tổng phí trước HQ',
		TotalPreCustomsFeeExchange: 'Tổng phí trước HQ quy đổi',
		TotalTaxValue: 'Tổng trị giá tính thuế',
		TotalTaxAmount: 'Tổng tiền thuế',
		TotalPaymentAmountExchange: 'Tổng tiền thanh toán quy đổi',
		CcyCode: 'Loại tiền',
		ExchangeRate: 'Tỷ giá',
		CompanyName: 'Công ty',
		CompanyTax: 'MST Công ty',
		BranchName: 'Chi nhánh',
		BranchTax: 'MST Chi nhánh',
		DepartmentName: 'Phòng ban',
		InventoryCode: 'Mã hàng',
		InvetoryItemName: 'Tên hàng hóa',
		UnitName: 'Đơn vị tính',
		Quantity: 'Số lượng',
		UnitPrice: 'Đơn giá',
		Amount: 'Thành tiền',
		AmountExchange: 'Thành tiền quy đổi',
		InvCustomsFeeExchange: 'Phí trước HQ quy đổi',
		TaxPrice: 'Trị giá tính thuế',
		ImportTax: 'TS thuế NK',
		ImportTaxAmount: 'Tiền thuế NK',
		TaxDumpingDetail: 'TS thuế CBPG',
		TaxDumpingDetailAmount: 'Tiền thuế CBPG',
		TTDBTax: 'TS thuế TTĐB',
		TTDBTaxAmount: 'Tiền thuế TTĐB',
		TaxEnvDetailAmount: 'Tiền thuế BVMT',
		VatTax: 'TS thuế GTGT',
		VatTaxAmount: 'Tiền thuế GTGT',
		TotalItemTaxAmount: 'Tổng tiền thuế',
		AmountAfterTax: 'Tổng tiền sau thuế'
	},
	InvoiceExportThirdParty: {
		OrderNumber: 'STT',
		CompanyName: 'Tên công ty',
		CompanyTax: 'MST công ty',
		BranchName: 'Tên chi nhánh',
		BranchTax: 'MST chi nhánh',
		DepartmentName: 'Tên phòng ban',
		BuyerName: 'Tên người mua',
		BuyerFullName: 'Họ tên người mua',
		BuyerAddress: 'Địa chỉ người mua',
		BuyerTaxCode: 'MST người mua',
		BuyerInvRevEmail: 'Email nhận hóa đơn',
		TemplateNo: 'Mẫu số',
		Series: 'Ký hiệu',
		InvoiceNo: 'Số hóa đơn',
		InvoiceDate: 'Ngày hóa đơn',
		SignedDate: 'Ngày ký',
		IssueDate: 'Ngày cấp mã',
		AccountingDate: 'Ngày hạch toán',
		SupplierCode: 'Mã người bán',
		SellerName: 'Tên người bán',
		SellerAddress: 'Địa chỉ người bán',
		SellerTaxCode: 'MST người bán',
		SellerBankAccount: 'STK người bán',
		PaymentMethod: 'Hình thức thanh toán',
		Explain: 'Diễn giải',
		TotalAmountWithoutVatDisplay: 'Tổng tiền hàng',
		TotalDiscountAmount: 'Tiền chiết khấu',
		TotalHasDiscount: 'Doanh số bán chưa thuế',
		TotalHasDiscountCC: 'Doanh số bán chưa thuế quy đổi',
		TaxReduction: 'Giảm thuế',
		VatRate: 'Thuế suất',
		TotalVATAmount: 'Thuế GTGT',
		TotalVATAmountCC: 'Thuế GTGT quy đổi',
		TotalFeesAmountXML: 'Tổng tiền phí',
		AmountOtherReduction: 'Tổng giảm trừ khác',
		SpecialItem: 'Loại HH đặc trưng',
		VehicleFrameNumber: 'Số khung',
		VehicleEngineNumber: 'Số máy',
		AssetType: 'Loại tài sản',
		AssetCondition: 'Tình trạng tài sản',
		Origin: 'Xuất xứ',
		SafetyQualityCertificateNumber: 'Số giấy chứng nhận ATKT & BVMT',
		FactoryInspectionSerialNumber: 'Số seri Phiếu KTCL xuất xưởng',
		ManufacturingCountryCode: 'Mã nước sản xuất',
		RegisteredAssetTypeName: 'Tên loại tài sản đăng ký',
		ManufacturingYear: 'Năm sản xuất',
		CommercialName: 'Tên thương mại',
		BrandName: 'Tên nhãn hiệu',
		VehicleModel: 'Kiểu loại xe',
		EngineDisplacementOrPower: 'Thể tích làm việc hoặc Công suất',
		PayloadWeight: 'Trọng tải',
		SeatingCapacity: 'Số người cho phép chở',
		TransportLicensePlate: 'Biển kiểm soát',
		DeparturePoint: 'Điểm đi',
		ArrivalPoint: 'Điểm đến',
		TransportedGoodsName: 'Tên hàng hóa vận chuyển',
		ShipperName: 'Tên người gửi hàng',
		ShipperAddress: 'Địa chỉ người gửi hàng',
		ShipperTaxCode: 'MST người gửi hàng',
		ShipperIdentifier: 'Số định danh người gửi hàng',
		LandParcelInfo: 'Thửa đất',
		AttachedToLandAssetInfo: 'Tài sản gắn liền với đất',
		TotalAmount: 'Tổng tiền thanh toán',
		CcyCode: 'Loại tiền',
		ExchangeRate: 'Tỷ giá',
		TotalAmountExchange: 'Tổng tiền quy đổi',
		StickName: 'Nhãn dán',
		RefNo: 'Số chứng từ',
		Accountant: 'Người hạch toán',
		Status: 'Kết quả kiểm tra',
		CostType: 'Loại chi phí',
		StatusInvoice: 'Trạng thái hóa đơn',
		NotificationWrong: 'Thông báo sai sót',
		LicensePlate: 'Biển số xe',
		Noted: 'Ghi chú',
		CostNorms: 'Định mức chi phí',
		BeyondTheNorm: 'Vượt định mức',
		HasPdf: 'Bản thể hiện hóa đơn',
		HasXml: 'Xml hóa đơn',
		LinkSearch: 'Link tra cứu',
		SearchCode: 'Mã tra cứu',

		// Tổng hợp
		RelativeInvoice: 'Hóa đơn liên quan',
		ChangeStatusInvoiceDate: 'Ngày thay đổi trạng thái trên CQT',
		ChangeStatusInvoiceOnSystemDate: 'Ngày phát hiện đổi trạng thái',
		CreatedDate: 'Ngày vào hệ thống',
		AmountReductionNotTax: 'Tổng giảm trừ không chịu thuế',
		// Chi tiết
		NatureText: 'Tính chất',
		UnitName: 'Đơn vị tính',
		UnitPrice: 'Đơn giá',
		Quantity: 'Số lượng',
		BatchNo: 'Số lô',
		ExpiredDate: 'Hạn sử dụng'
	},
};
